import { forwardRef, SkeletonText } from "@chakra-ui/react";

export const SkeletonTextComponent = forwardRef(
  ({ children, ...restProps }, ref) => (
    <SkeletonText ref={ref} {...restProps}>
      {children}
    </SkeletonText>
  ),
);
